var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-ticket-detail-sidebar-single-offer-container pt-4"},[_c('TicketOfferCardVariant1',{attrs:{"item":_vm.item,"ticket":_vm.ticket,"max-quantity":_vm.item.quantity,"is-multiple-offers":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }